import { render, staticRenderFns } from "./CouponsWithDiscount.vue?vue&type=template&id=80728408"
import script from "./CouponsWithDiscount.vue?vue&type=script&lang=js"
export * from "./CouponsWithDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports